exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "body.ant-scrolling-effect {\n  width: 100% !important;\n}\n.header {\n  height: 150px !important;\n}\n.sider {\n  display: none;\n}\n/* Large */\n@media only screen and (min-width: 992px) {\n  .header {\n    display: none;\n  }\n  .sider {\n    display: block;\n  }\n}\n", ""]);

